module.exports = __webpack_public_path__ + "static/media/arrows-up-right.a3ed0676.svg";